import React, { FC } from 'react';

import { MainScreenTab } from '../../../utils/navigation';

import BuildingList from './components/buildingList';

interface Props {
  tab: MainScreenTab;
}

const Buildings: FC<Props> = ({ tab }) => <BuildingList tab={tab} />;

export default Buildings;
